import React from "react";

const Container = ({ children }) => {
  return <div className="challenge-lp__container">{children}</div>;
};
export default Container;
